import { render } from "./EmojiListContainer.vue?vue&type=template&id=396fc8bb&scoped=true&ts=true"
import script from "./EmojiListContainer.vue?vue&type=script&lang=ts"
export * from "./EmojiListContainer.vue?vue&type=script&lang=ts"

import "./EmojiListContainer.vue?vue&type=style&index=0&id=396fc8bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396fc8bb"]])

export default __exports__